var _desc, _defs, _circle, _g, _g2, _g3, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPepsicologo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Pepsi-style globe (approximation)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Red upper hemisphere, white wavy stripe, blue lower hemisphere \u2014 clipped to a circular globe.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circleClip"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 95
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "shine",
    cx: "35%",
    cy: "30%",
    r: "80%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 95,
    fill: "#0C4DA2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circleClip)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 H200 V70              C170 95 130 90 100 90              C70 90 30 95 0 70              Z",
    fill: "#E41F26"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circleClip)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 68              C35 90 65 92 100 78              C135 64 165 66 200 88              L200 125              C165 143 135 146 100 135              C65 124 35 128 0 125              Z",
    fill: "#ffffff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circleClip)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 60,
    r: 50,
    fill: "url(#shine)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 95,
    fill: "none",
    stroke: "#0b2b45",
    strokeOpacity: 0.18,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepsicologo);
export default __webpack_public_path__ + "static/media/pepsico logo.f870ad91b0df6bdd9afaca76fa833c4a.svg";
export { ForwardRef as ReactComponent };